import axios from 'axios';

export type ApiClient = {
  id: string;
  clientId: string;
  name: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  lastUsedAt?: string;
};

export type CreateClientRequest = {
  name: string;
  description?: string;
};

export type CreateClientResponse = {
  message: string;
  warning: string;
  credentials: {
    clientId: string;
    clientSecret: string;
  };
  client: ApiClient;
};

class ServiceApiClients {
  private baseUrl = '/api/api-clients';

  async listClients(): Promise<ApiClient[]> {
    const response = await axios.get(this.baseUrl);
    return response.data.clients;
  }

  async createClient(data: CreateClientRequest): Promise<CreateClientResponse> {
    const response = await axios.post(this.baseUrl, data);
    return response.data;
  }

  async deleteClient(id: string): Promise<void> {
    await axios.delete(`${this.baseUrl}/${id}`);
  }
}

export const serviceApiClients = new ServiceApiClients();
export default serviceApiClients;
